import React from "react";
import { FaDownload } from "react-icons/fa";
import Section from "./Section";
import "./About.css";
import "./Section.css";

const Resume = () => (
  <Section id="resume" title="Resume">
    <div className="section-content">
      <p>You can find my complete resume below:</p>
      <br /> {/* Line break for extra space */}
      <div className="button-container">
        <a
          href="/resume.pdf"
          download="GONCALVES_TAIGA_resume.pdf"
          className="download-button"
        >
          <FaDownload className="button-icon" /> Download Resume
        </a>
      </div>
    </div>
  </Section>
);

export default Resume;
